/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ContractReviewerType {
  COMMON = 'COMMON',
  JURIDICAL = 'JURIDICAL',
}
